<template>
  <div style="position: relative;">

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select v-model='theUmpType' @change="theUmpTypeAllChange" size="small" clearable placeholder="请选择类型">
            <el-option
                v-for="item in theUmpTypeAll"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
        <el-input
          v-model="getUserMorePointsList_data.userName"
          placeholder="请输入用户名称"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getUserMorePointsList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>

      </el-col>

      <el-col :span="6" v-if="theUserProject!=0">
         <el-button
         type="primary"
         icon="el-icon-star-on"
         size='small'
         style="float: right;"
          @click = "formopen()"
         >手动调整积分</el-button>
      </el-col>

    </el-row>

    <div style="width: 100%; height: 100%; background-color: white; position: absolute;top: 0;left: 0;z-index:666;" v-if="formshow == 1">
      <el-row style="text-align: right;margin: 15px;">
        <el-button type="danger" icon="el-icon-error" circle @click="formclose()"></el-button>
      </el-row>
      <div style="width: 70%;margin: 50px auto;padding: 50px;">
        <el-form  :model="formdata" size="medium" ref="formdata" :rules="rules" >
           <el-row style="width: 80%; margin: 20px auto;">
              <el-col :span="12">
                <el-form-item label="选择用户" xprop="userId" >
                  <el-select v-model="formdata.userId" @focus="getProjectUserList({dtId:formdata.dtId,postId:5})" clearable>
                    <el-option v-for="item in (getProjectUserList_data||0).data||[]"
                     :key="item.userId"
                     :label="item.userName"
                     :value="item.userId"
                     >

                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

             </el-row>

             <el-row style="width: 80%; margin: 20px auto;">
               <el-form-item label="积分数量" prop="umpNum">
                 <el-input-number v-model="formdata.umpNum"  :min="1" ></el-input-number>
               </el-form-item>
             </el-row>

             <el-row style="width: 80%; margin: 20px auto;">
               <el-form-item label="积分描述" prop="umpRemark">
                 <el-input style="width: 60%;" v-model="formdata.umpRemark"></el-input>
               </el-form-item>
             </el-row>

             <el-row style="width: 80%; margin: 20px auto;">
               <el-form-item label="是加还是减" prop="addOrPlus">
                 <el-radio v-model="formdata.addOrPlus" :label="1">加积分</el-radio>
                 <el-radio v-model="formdata.addOrPlus" :label="2">减积分</el-radio>
               </el-form-item>
             </el-row>
             <el-row style="width: 60%; margin: 20px auto;padding-left: 100px;">

                 <el-button type="success" round @click="sub()" size="medium" style="width: 200px;">提交</el-button>

               <!-- <el-col :span="12">
                 <el-button type="info" round  @click="rest('formdata')">重置</el-button>
               </el-col> -->
             </el-row>
        </el-form>

      </div>

    </div>



    <mytable
      :tableColums='tableColums_getUserMorePointsList'
      api='getUserMorePointsList'
      xupdateapi='updateUserMorePoints'
      :height="H-165" >
    </mytable>

  </div>
</template>

<script>
export default {
  data() {
    return {
      rules:{
        userId:[
           { required: true, message: '请选择用户', trigger: 'change' }
        ],
        umpNum:[
          { required: true, message: '请添加积分', trigger: 'change' }
        ],
        umpRemark:[
           { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        dtId:[
          { required: true, message: '请选择网格', trigger: 'change' }
        ],
        addOrPlus:[
           { required: true, message: '请选择加积分还是减积分', trigger: 'change' }
        ]

      },
      formdata:{
        userId:"",//用户id
        umpNum:1,//积分数量
        umpRemark:"",//理由
        addOrPlus:1,//加还是减
        dtId:null, //战队id
      },
      formshow :"2",
      theProjectId:"",
      theUserProject:"",

      theUmpType:"",

      theUmpTypeAll:[
          {id:1,name:"订单"},
          {id:2,name:"打卡"},
          {id:3,name:"签到"},
          {id:4,name:"案例分享"},
          {id:5,name:"调整"},
      ],
  //1订单 2拜访 3签到 4案例分享
      tableColums_getUserMorePointsList: {
        $selection: false,

        umpType: ['类型',,'@v-if: 1:订单, 2:打卡#primary, 3:签到#danger, 4:案例分享#danger'],
        umpType: ['类型',,'@v-if: 1:订单, 2:打卡#primary, 3:签到#danger, 4:案例分享#danger, 5:调整#danger'],

        umpRemark: '描述',

        umpNum: '积分',

        userName: '用户',

        createtime: '时间',

      },

      /* testList: [{"dtId":6,"dtName":"网格1","dtParentId":5,"dtPriority":1,"dtLevel":4,"createuserid":1,"createtime":"2020-11-11 17:09:25","ownership":1,"dtChatGroupid":null,"dtChatStatus":200,"children":null},{"dtId":7,"dtName":"网格2","dtParentId":5,"dtPriority":2,"dtLevel":4,"createuserid":1,"createtime":"2020-11-11 17:09:25","ownership":1,"dtChatGroupid":null,"dtChatStatus":200,"children":null},{"dtId":87,"dtName":"网格3","dtParentId":5,"dtPriority":3,"dtLevel":4,"createuserid":2,"createtime":"2021-04-26 16:24:10","ownership":1,"dtChatGroupid":null,"dtChatStatus":null,"children":null},{"dtId":88,"dtName":"网格四","dtParentId":5,"dtPriority":4,"dtLevel":4,"createuserid":2,"createtime":"2021-04-26 17:49:50","ownership":1,"dtChatGroupid":null,"dtChatStatus":null,"children":null}], */
    };
  },

  watch: {

  },

  methods: {

     async sub(){
      this.addUserMorePointsManage({
        userId:this.formdata.userId,//用户id
        umpNum:this.formdata.umpNum,//积分数量
        umpRemark:this.formdata.umpRemark,//理由
        addOrPlus:this.formdata.addOrPlus,//加还是减
      },'正在提交').result(res=>{
          if(!res) return;
          alertSuccess('提交成功!');
            this.formdata = {
              userId:"",//用户id
              umpNum:1,//积分数量
              umpRemark:"",//理由
              addOrPlus:1,//加还是减
              dtId:null, //战队id
            }
        });
    },
     formopen(){
       this.formshow = 1;
     },
     formclose(){
       this.formshow=2
       this.formdata = {
         userId:"",//用户id
         umpNum:1,//积分数量
         umpRemark:"",//理由
         addOrPlus:1,//加还是减
         dtId:null, //战队id
       }
     },
      theProjectAllChange(e){
          this.theProjectId=e;
          this.getUserMorePointsList({projectId:this.theProjectId,umpType:this.theUmpType});
      },
      theUmpTypeAllChange(e){
          this.theUmpType=e;
          this.getUserMorePointsList({projectId:this.theProjectId,umpType:this.theUmpType});
      }
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getUserMorePointsList({projectId:this.theProjectId,umpType:this.theUmpType});
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/PointsManage.vue